import { toCappedCountText } from "@mgdx/shared/src/utils/toCappedCountText";
import { cx } from "cva";
import React from "react";

import { BadgeProps, variants } from ".";

const Badge = ({ className, variant, color, size, number, ...props }: BadgeProps) => (
  <span className={cx(className, variants({ variant, color, size }))} {...props}>
    {!!number && toCappedCountText(number)}
  </span>
);

export default Badge;
